import Modal from "../../../modules/modal";
var Label = /** @class */ (function () {
    function Label(column) {
        this.column = column;
        this.setting = column.el.querySelector('.ac-column-setting--label');
        this.iconpicker = this.setting.querySelector('.-iconpicker');
        if (!this.iconpicker) {
            return;
        }
        this._dashicon = false;
        this.modal = AdminColumns.Modals.register(new Modal(this.setting.querySelector('.-iconpicker')));
        this.field = this.setting.querySelector('.ac-setting-input_label');
        this.initValue();
        this.bindEvents();
    }
    Label.prototype.initValue = function () {
        var self = this;
        var html = document.createRange().createContextualFragment(this.getValue());
        var dashicon = html.querySelector('.dashicons');
        if (dashicon) {
            var classList = dashicon.classList;
            classList.forEach(function (cls) {
                if (cls.indexOf('dashicons-') !== -1) {
                    var selector = '.' + cls;
                    var icon = self.iconpicker.querySelector(selector);
                    if (icon) {
                        icon.parentElement.classList.add('active');
                        self.setIconSelection(icon.parentElement.dataset.dashicon);
                    }
                }
            });
        }
        else {
            self.setIconSelection(false);
        }
    };
    Label.prototype.bindEvents = function () {
        var self = this;
        this.setting.querySelector('.ac-setting-label-icon').addEventListener('click', function (e) {
            e.preventDefault();
            self.modal.open();
        });
        this.setting.querySelector('[data-action="submit"]').addEventListener('click', function (e) {
            e.preventDefault();
            if (self.getIconSelection()) {
                self.setDashicon(self.getIconSelection());
            }
            self.modal.close();
        });
        var icons = this.iconpicker.querySelectorAll('.ac-ipicker__icon');
        icons.forEach(function (icon) {
            icon.addEventListener('click', function (e) {
                e.preventDefault();
                var dashicon = this.dataset.dashicon;
                if (dashicon) {
                    self.setIconSelection(dashicon);
                }
                var icons = self.setting.querySelectorAll('.ac-ipicker__icon');
                icons.forEach(function (icon) {
                    icon.classList.remove('active');
                });
                icon.classList.add('active');
            });
        });
    };
    Label.prototype.getValue = function () {
        return this.field.value;
    };
    Label.prototype.setValue = function (value) {
        this.field.value = value;
        var event = new Event('change');
        this.field.dispatchEvent(event);
    };
    Label.prototype.setIconSelection = function (dashicon) {
        var selection = this.setting.querySelector('.ac-ipicker__selection');
        this._dashicon = dashicon;
        selection.innerHTML = "<span class=\"dashicons dashicons-" + dashicon + "\"></span>";
        if (!dashicon) {
            selection.style.visibility = 'hidden';
        }
        else {
            selection.style.visibility = 'visible';
        }
    };
    Label.prototype.getIconSelection = function () {
        return this._dashicon;
    };
    Label.prototype.setDashicon = function (dashicon) {
        this.setValue("<span class=\"dashicons dashicons-" + dashicon + "\"></span>");
    };
    return Label;
}());
var label = function (column) {
    column.settings.label = new Label(column);
};
export default label;
